import React from "react";

export function IconCheck() {
    return (
        <svg fill="currentColor" viewBox="0 0 16 12">
            <path d="M4.94 9.698L1.625 6.386A.951.951 0 10.279 7.732l3.992 3.989a.952.952 0 001.346 0L15.721 1.625A.952.952 0 1014.374.279L4.94 9.698z"></path>
        </svg>
    );
}
